<script>
import _ from 'lodash'
export default {
    name: 'hasQueryParams',
    data: () => ({
        queryFields: []
    }),
    computed: {
        query () {
            return {}
        }
    },
    watch: {
        '$route.query': {
            deep:true,
            handler(r){
                if(!this.areIdenticalQueries(this.query, r)){
                    this.parseQuery()
                }
            }
        }
    },
    methods: {
        areIdenticalQueries(originalQuery, newQuery){
            let identical=true
            this.queryFields.forEach(f => {
                if (originalQuery[f] != newQuery[f]) {
                    identical=false
                }
            });
            return identical
        },
        pushNewRoute(){
            if(!this.areIdenticalQueries(this.$route.query, this.query)){
                if( _.isEmpty(this.$route.query)){
                    console.log('replace')
                    this.$router.replace({query: { ...this.$route.query, ...this.query}})
                }else{
                    this.$router.push({query: { ...this.$route.query, ...this.query}})
                }
            }
        },
    }
}
</script>
